import React from 'react';
import Img from 'graphcms-image';

const FeatureCard = ({ featuredImage }) => {
  if (!featuredImage) return null;

  return (
    <div className="max-w-5xl w-full">
      <Img
        image={featuredImage}
        maxWidth={560}
        transforms={['quality=value:75']}
        withWebp
      />
    </div>
  );
};

export default FeatureCard;
